import VideoStatus from 'enums/VideoStatus';
import { select, takeEvery } from 'redux-saga/effects';
import { put } from 'store/utils';
import * as videoActions from 'store/video/videoActions';
import * as messageActions from 'store/message/messageActions';
import upstreamVideoQualities from 'constants/upstreamVideoQualities';

export function* toggleVideoFlowSaga(action) {
  yield put(videoActions.initAction({ key: 'toggleVideo' }));
  try {
    const { presenterAttendeeId = '', toggleRemoteAttendee = false, forceLocalOff = false } =
      action?.payload || {};
    const { upstreamVideoQuality, videoStatus, audioVideo, currentVideoInputDevice } = yield select(
      ({ video, chime }) => ({
        videoStatus: video.videoStatus,
        audioVideo: chime.audioVideo,
        currentVideoInputDevice: chime.currentVideoInputDevice,
        upstreamVideoQuality: chime.upstreamVideoQuality,
      })
    );
    if (toggleRemoteAttendee && presenterAttendeeId) {
      yield put(
        messageActions.sendMessageAction({
          type: 'stop-presenter-video',
          payload: {
            presenterAttendeeId,
          },
        })
      );
    } else if (forceLocalOff) {
      audioVideo.stopLocalVideoTile();
      yield put(videoActions.toggleVideoStatusAction(VideoStatus.Disabled));
    } else {
      yield put(videoActions.toggleVideoStatusAction(VideoStatus.Loading));
      if (videoStatus === VideoStatus.Disabled) {
        if (!currentVideoInputDevice) {
          throw new Error('currentVideoInputDevice does not exist');
        }

        const { width, height, frameRate, maxBandwidthKbps } = upstreamVideoQualities[
          upstreamVideoQuality
        ];
        yield audioVideo.chooseVideoInputQuality(width, height, frameRate, maxBandwidthKbps);

        yield audioVideo.chooseVideoInputDevice(currentVideoInputDevice);
        audioVideo.startLocalVideoTile();
        yield put(videoActions.toggleVideoStatusAction(VideoStatus.Enabled));
      } else if (videoStatus === VideoStatus.Enabled) {
        audioVideo.stopLocalVideoTile();
        yield put(videoActions.toggleVideoStatusAction(VideoStatus.Disabled));
      }
    }
    yield put(videoActions.successAction({ key: 'toggleVideo' }));
  } catch (error) {
    yield put(videoActions.toggleVideoStatusAction(VideoStatus.Disabled));
    yield put(videoActions.errorAction({ key: 'toggleVideo', error }));
  }
}

export default function* videoWatcher() {
  yield takeEvery(videoActions.toggleVideoAction().type, toggleVideoFlowSaga);
}
